
import { ConsultaOrdemDeProducaoFiltro, DadosOrdemDeProducao } from "app/components/ordem-producao/consulta-ordem-de-producao/ConsultaOrdemDeProducao";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";
import { DadosOrdemProducao, DadosOrdemProducaoCombinados, DadosSalvarOrdemProducao, EtapaOrdemProducao, DadosHistoricoOrdemProducao, InsumoOrdemProducao, NecessitaAutorizacaoOrdemProducao } from "app/types/OrdemProducao";
import { ResultadoOperacao } from "../types/ResultadoOperacao";

export class OrdemProducaoApi extends BaseApi {
    /*
    async ListarPedidosOrdemProducao(filtros: Partial<OrdemProducaoApi.FiltroListaOrdemProducao>): Promise<Partial<PagedMessageResponse<ConsultaOrdemDeProducao>>> {
        const resposta = await this.api.post(`/OrdemProducao/ListarPedidosOrdemProducao`, {
            filtros
        })

        return resposta?.data
    }
        */
    async ListarPedidosOrdemProducao(filtro: Partial<ConsultaOrdemDeProducaoFiltro>): Promise<Partial<PagedMessageResponse<DadosOrdemDeProducao>>>
    {
        const resposta = await this.api.post(`/OrdemProducao/ListarPedidosOrdemProducao`, filtro)
        return resposta?.data
    }

    async ObterDadosParaFiltroOrdeProducao(): Promise<ConsultaOrdemDeProducaoFiltro>
    {
        const resposta = await this.api.post(`/OrdemProducao/ObterDadosParaFiltroOrdeProducao`, {})
        return resposta?.data
    }

    async ObterDadosOrdemProducao(filtros: Partial<OrdemProducaoApi.FiltroOrdemProducao>, numeroPedido: number): Promise<Partial<DadosOrdemProducao>> {


        const resposta = await this.api.post(`/OrdemProducao/ObterDadosOrdemProducao`, {
            filtros,
            numeroPedido
        })

        return resposta?.data
    }

    async ConsultarInsumosInclusao(filtros: Partial<OrdemProducaoApi.FiltroConsultarInsumosInclusao>): Promise<InsumoOrdemProducao[]> {
        const resposta = await this.api.post(`/OrdemProducao/ConsultarInsumosInclusao`, {
            filtros,
        })

        return resposta?.data
    }

    async SalvarOrdemProducao(filtros: Partial<OrdemProducaoApi.FiltroSalvarOrdemProducao>): Promise<ResultadoOperacao<OrdemProducaoApi.SalvarOrdemProducao>> {


        const resposta = await this.api.post(`/OrdemProducao/SalvarOrdemProducao`, {
            filtros
        })

        return resposta?.data
    }

    async VerificarAutorizacaoOrdemProducao(filtros: Partial<OrdemProducaoApi.VerificarAutorizacaoOrdemProducao>): Promise<NecessitaAutorizacaoOrdemProducao> {
        const resposta = await this.api.post(`/OrdemProducao/VerificarAutorizacaoOrdemProducao`, {
            filtros
        })

        return resposta?.data
    }
}

export namespace OrdemProducaoApi {
    // export type FiltroListaOrdemProducao = {
    //     NumeroPedido: string
    //     CodigoVendedor: string
    //     TamanhoPagina: number
    //     NumeroPagina: number
    // }

    export type FiltroConsultarInsumosInclusao = {
        CodigoProduto: string
        ListaProdutosJaInformados: string
        Filial: string
        Quantidade: number
    }

    export type FiltroOrdemProducao = {
        CodigoItemPedido: number
        CodigoProduto: string
        CodigoOrdemProducao: number
        QuantidadeItem: number
        CodigoFilial: string
        Nivel: number
    }

    export interface FiltroSalvarOrdemProducao {
        Dados: Partial<DadosSalvarOrdemProducao>,
        DadosInsumoOrdemProducao: InsumoOrdemProducao[]
        SenhaLiberacao: string
        DadosHistoricoOrdemProducao: Partial<DadosHistoricoOrdemProducao>
    }

    export interface SalvarOrdemProducao {
        MensagemSucesso:string
        Sucesso: boolean
    }

    export interface VerificarAutorizacaoOrdemProducao {
        Insumos:InsumoOrdemProducao[]
        NumeroPedido: number
        IdSituacao: number
    }
}